import Icon from '../components/Icon.vue'

Icon.register({
  glasses: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M574.1 280.4L528.8 98.7C522.8 75 507.2 54.6 485.8 42.9 464.3 31.1 438.8 28.7 415.6 36.5L400.3 41.6C391.9 44.4 387.4 53.5 390.2 61.8L395.3 77C398 85.4 407.1 89.9 415.5 87.1L428.7 82.8C439.5 79.1 451.7 79.2 461.8 84.5 472.1 89.9 479.4 99 482.2 110.3L520.7 264.1C498.5 257.3 470.9 251.7 439.5 251.7 404.7 251.7 365.5 258.7 324.6 278.4H251.4C210.6 258.7 171.3 251.7 136.6 251.7 105.1 251.7 77.5 257.3 55.4 264.1L93.8 110.3C96.6 99 103.9 89.8 114.2 84.5 124.4 79.2 136.5 79.1 147.3 82.7L160.5 87.1C168.9 89.9 178 85.4 180.7 77L185.8 61.8C188.6 53.4 184.1 44.4 175.7 41.6L160.4 36.5C137.2 28.7 111.7 31.1 90.2 42.8 68.8 54.6 53.2 74.9 47.2 98.6L1.9 280.4A64.2-64.2 0 0 1 0 295.9V366.1C0 429 51.6 480 115.2 480H152.3C212.6 480 262.7 434.1 267.2 374.6L270.1 336H305.9L308.8 374.6C313.3 434.1 363.4 480 423.7 480H460.8C524.4 480 576 429 576 366.1V295.9C576 290.6 575.4 285.4 574.1 280.4zM203.4 369.8C201.4 395.7 179 416 152.3 416H115.2C87 416 64 393.6 64 366.1V328.6C82.1 322.1 107.4 315.6 136.6 315.6 160.4 315.6 183.8 320 206.5 328.6L203.4 369.8zM512 366.1C512 393.6 489 416 460.8 416H423.7C397 416 374.6 395.7 372.6 369.8L369.5 328.6C392.2 320 415.6 315.6 439.4 315.6 468.6 315.6 493.9 322.1 512 328.6V366.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/glasses.js
// module id = p9Vk
// module chunks = 144